<template>
  <a-modal :open="open" @cancel="closeForm" class="modal-no-padding">
    <div class="modal-no-padding__header">
      <h2>Копирование группы</h2>
    </div>
    <a-divider style="margin: 16px 0" />
    <div class="modal-no-padding__body">
      <span>Название группы</span>
      <a-input v-model:value="groupForm.name" :status="statusError.groupName ? 'error' : ''"/>
      <span v-if="statusError.groupName">
        Ввведите название группы
      </span>
    </div>

    <template #footer>
      <a-divider style="margin: 16px 0" />
      <div class="modal-no-padding__footer">
        <div class="action-buttons">
          <a-row justify="end" :gutter="8">
            <a-col>
              <a-button class="secondary-button" @click="closeForm">Отменить</a-button>
            </a-col>
            <a-col>
              <a-button class="primary-button" :loading="modalActionLoading" @click="handleCopyGroup">Отправить</a-button>
            </a-col>
          </a-row>
        </div>
      </div>
    </template>
  </a-modal>
</template>

<script>
import {message} from "ant-design-vue";
import {useStore} from "vuex";
import {reactive, ref} from "@vue/runtime-core";

export default {
  props: {
    open: Boolean,
    currentGroupId: Number,
    name: String,
  },
  emits: ['submitted', 'close'],
  setup(props, context) {
    const store = useStore();
    const modalActionLoading = ref(false);
    const groupToCopyIn = ref();

    const groupForm = reactive({
      name: props.name ?? '',
    });

    const statusError = reactive({
      groupName: false,
    });

    const handleCopyGroup = () => {
      if (!groupForm.name || groupForm.name.length < 5) {
         statusError.groupName = true;
         return;
      } else {
        statusError.groupName = false;
      }

      modalActionLoading.value = true;

      store.dispatch('group/copyGroup', {...groupForm, groupId: props.currentGroupId}).then(() => {
        message.success('Группа скопирована');
        context.emit('submitted');
      });
    }

    const closeForm = () => {
      context.emit('close');
    }

    return {
      groupToCopyIn,
      modalActionLoading,
      closeForm,
      groupForm,
      statusError,
      handleCopyGroup
    }
  }
}
</script>

<style scoped lang="scss">

</style>